import axios from "axios";
import { BASE_URL } from "./config";
import { setToken, doLogout, getAuthItem } from "./utils/auth";

const API = axios.create({
  baseURL: BASE_URL, // live backend
  // send cookies (session) on cross-site requests
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// attach token automatically
API.interceptors.request.use((req) => {
  const token = getAuthItem("token");
  // Filter out invalid token values
  if (token && token !== 'null' && token !== 'undefined' && token.trim() !== '') {
    req.headers.Authorization = `Bearer ${token}`;
  }
  return req;
});

// Response interceptor: on 401 try to refresh access token once
API.interceptors.response.use(
  (res) => res,
  async (error) => {
    const originalRequest = error.config;
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const r = await axios.post(`${BASE_URL}/auth/refresh`, {}, { withCredentials: true });
        if (r.data && r.data.token) {
          if (sessionStorage.getItem('token')) {
            sessionStorage.setItem('token', r.data.token);
            window.dispatchEvent(new Event('authUpdate'));
            // Note: setToken in auth.js uses local, so we handle session manually here unless we update auth.js logic
          } else {
            setToken(r.data.token);
          }
          originalRequest.headers.Authorization = `Bearer ${r.data.token}`;
          return API(originalRequest);
        }
      } catch (e) {
        // refresh failed
        doLogout();
        return Promise.reject(e);
      }
    }
    return Promise.reject(error);
  }
);

export default API;
